import { LABEL_ORDER_DETAILS_INITIALIZE } from "../../constants/labelOrderDetails";

export const initialize = () => {
  return { type: LABEL_ORDER_DETAILS_INITIALIZE };
};
 